<template>
  <div class="history-content">
    <v-switch
      color="green"
      v-model="trainer_switches.country_filter"
      label="Filtern nach Wohnsitz (Land)"
    ></v-switch>
    <div v-if="trainer_switches.country_filter">
      <label>Land</label>
      <v-autocomplete
        color="green"
        :items="$store.state.countries"
        v-model="user_data.trainer_country"
        solo
      ></v-autocomplete>
    </div>
    <v-switch
      color="green"
      v-model="trainer_switches.region_filter"
      label="Filtern nach Region/Verband"
    ></v-switch>
    <div v-if="trainer_switches.region_filter">
      <label>Region/Verband</label>
      <v-select
        color="green"
        :items="$store.state.verband"
        v-model="user_data.trainer_verband"
        solo
      ></v-select>
      <div v-if="user_data.trainer_verband">
        <label>Liga</label>
        <v-select
          solo
          color="green"
          :items="$store.state.filter_leagues[user_data.trainer_verband]"
          item-text="league"
          item-value="category"
          v-model="user_data.trainer_category"
          multiple
        ></v-select>
      </div>
    </div>

    <v-switch
      color="green"
      v-model="trainer_switches.sex_filter"
      label="Filtern nach Geschlecht"
    ></v-switch>
    <div v-if="trainer_switches.sex_filter">
      <label for>Geschlecht</label>
      <v-select
        solo
        color="green"
        :items="$store.state.sex"
        v-model="user_data.trainer_sex"
        multiple
      ></v-select>
    </div>
    <v-switch
      color="green"
      v-model="trainer_switches.type_filter"
      label="Filtern nach Trainertyp"
    ></v-switch>
    <div v-if="trainer_switches.type_filter">
      <label for>Trainertyp</label>
      <v-select
        solo
        color="green"
        :items="$store.state.trainer_types"
        v-model="user_data.trainer_types"
        multiple
      ></v-select>
    </div>
    <v-switch
      color="green"
      v-model="trainer_switches.license_filter"
      label="Filtern nach Lizenz"
    ></v-switch>
    <div v-if="trainer_switches.license_filter">
      <label for>Trainerlizenz</label>
      <v-select
        solo
        color="green"
        :items="$store.state.trainer_license"
        v-model="user_data.trainer_license"
        multiple
      ></v-select>
    </div>
    <v-switch
      color="green"
      v-model="trainer_switches.language_filter"
      label="Filtern nach Sprache"
    ></v-switch>
    <div v-if="trainer_switches.language_filter">
      <label for>Sprache</label>
      <v-select
        solo
        color="green"
        :items="$store.state.languages"
        v-model="user_data.trainer_languages"
        multiple
      ></v-select>
    </div>
    <v-switch
      color="green"
      v-model="trainer_switches.age_filter"
      label="Filtern nach Alter"
    ></v-switch>
    <div v-if="trainer_switches.age_filter">
      <label>Alter</label>
      <v-range-slider
        solo
        color="green"
        thumb-label="always"
        class="age-slider"
        :min="14"
        :max="80"
        @end="changeSlider"
      ></v-range-slider>
    </div>
    <v-switch
      color="green"
      v-model="trainer_switches.no_team"
      label="Filtern nach Vereinslos"
    ></v-switch>

    <v-btn
      flat
      @click="resetFilters('trainer_switches')"
      class="reset-filter-button button-small"
    >
      <v-icon class="mr-2">undo</v-icon> Alle Filter zurücksetzen
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'trainer-filter',

  props: {
    trainer_switches: {
      type: Object,
      default: () => {},
    },
    user_data: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    changeSlider(value) {
      this.user_data.trainer_age_range = value;
      this.user_data.trainerAgeRange = this.user_data.trainer_age_range;
      this.trainer_switches.age_filter = false;
      this.trainer_switches.age_filter = true;
    },

    resetFilters(type) {
      this.$emit('reset-filters', type);
    },
  },
};
</script>
